var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.config.ecommerceActive)?_c('AppointmentsLayout',[_vm._t("default")],2):(!_vm.config.appointmentsActive)?_c('StoreLayout',[_vm._t("default")],2):_c('StoreAppointmentsLayout',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }